import React, { useState, useEffect } from "react";
import userphone from "src/assets/images/user-phone-icon.svg";
import useremail from "src/assets/images/user-email-icon.svg";
import usersource from "src/assets/images/user-source-icon.svg";
import usercreated from "src/assets/images/user-create-icon.svg";
import { useUserStore } from "../../../hooks/admin/user";
import { __remove, __set } from "src/store/axios_indicator";
import Helper from "src/helper/Helper";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import useReduxState from "src/hooks/useReduxState";
import System from "src/helper/system";
import { useObjCommonFilterStore } from '../../../hooks/objCommonFilter';
import AxiosIndicatorRunTimeLoader from "src/component/Global/AxiosIndicatorRunTimeLoader";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";

const UserDetailHeader = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const [isEdit, setIsEdit] = useReduxState(false, "setIsEdit");
  const [{ userDetail }, { get_user_detail }, { update_user_detail, update_user_active_status }] =
    useUserStore();
  const userId = props.userId;
  const userType = props.userType;
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    telephoneNumber: "",
    companyName: "",
    isActive: ""
  });
  const [userValidation, setUserValidation] = useState({});
  const [{ }, { }, { clear_all_filter }] = useObjCommonFilterStore();
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

  useEffect(() => {
    async function fetchHere() {
      __set("USER_DETAIL_API_CALL");
      const data = await get_user_detail(userId);
      if (data?.payload?.Message) {
        system_alert_indicator({
          name: "accessDenied",
          message: data?.payload?.Message,
          type: "danger",
          isDisplayIcon: true,
          isDisplay: false
        });
      }
      setTimeout(() => {
        __remove("USER_DETAIL_API_CALL");
      }, 2000);
    }

    fetchHere();
  }, []);

  const openPopup = () => {
    clear_all_filter()
    System.popup('SponsorUserAcct', { userDetail, userId, userType })
  };

  const onEditUser = () => {
    setUser({
      firstName: userDetail?.firstName,
      lastName: userDetail?.lastName,
      mobileNumber: userDetail?.mobileNumber ? userDetail?.mobileNumber : "",
      telephoneNumber: userDetail?.telephoneNumber
        ? userDetail?.telephoneNumber
        : "",
      userId: userDetail?.id,
      companyName: userDetail?.companyName ? userDetail?.companyName : "",
      isActive: userDetail?.active
    });
    setUserValidation({});
    setIsEdit(true);
  };

  const onSubmit = async () => {
    const validationModal = {};

    Helper.valueIsNotNull(user.firstName) ? "" : (validationModal.firstName = "First name must not contain numbers and special characters.");
    Helper.valueIsNotNull(user.lastName) ? "" : (validationModal.lastName = "Last name must not contain numbers and special characters.");
    setUserValidation(validationModal);
    const isValid = Object.keys(validationModal).length <= 0;

    if (System.validateDomain(userDetail?.emailAddress)) {

      __set("USER_DETAIL_API_CALL");
      const data = {
        isActive: user.isActive,
        id: userId
      }
      setIsEdit(false);
      const result = await update_user_active_status(data)

      const res = await get_user_detail(userId);
      if (res?.payload?.Message || result?.payload?.Message) {
        system_alert_indicator({
          name: "accessDenied",
          message: data?.payload?.Message,
          type: "danger",
          isDisplayIcon: true,
          isDisplay: false
        });
      }
      __remove("USER_DETAIL_API_CALL");
    } else {
      if (isValid) {
        __set("USER_DETAIL_API_CALL");
        setIsEdit(false);
        await update_user_detail(user);
        const res = await get_user_detail(userId);
        if (res?.payload?.Message) {
          system_alert_indicator({
            name: "accessDenied",
            message: data?.payload?.Message,
            type: "danger",
            isDisplayIcon: true,
            isDisplay: false
          });
        }
        __remove("USER_DETAIL_API_CALL");
      }
    }
  };

  const onValueChange = (field, value) => {
    if (userValidation && Object.keys(userValidation).length > 0) {
      delete userValidation[field];
    }
    setUser({ ...user, [field]: value });
  };

  return (
    <>
      {__check(["USER_DETAIL_API_CALL", "USER_ACCOUNT_API_CALL"]).status ? <AxiosIndicatorRunTimeLoader /> : (
        <div className="userdetails bg-gray3 mt-4">
          <div className="container">
            <div className="user-details-top">
              <div className="user-details-tleft">
                <div className="user-details-name  mb-3">
                  {isEdit && !System.validateDomain(userDetail?.emailAddress) ? (
                    <>
                      <div className="d-flex align-items-center user-contact">
                        <div className="me-3">
                          <label>First Name</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder="First Name"
                            type="text"
                            value={user.firstName}
                            onChange={({ target: { value } }) => {
                              const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
                              onValueChange("firstName", filteredValue);
                            }}
                            maxLength={20}
                          />
                          {userValidation.firstName && (
                            <p className="error"> {userValidation.firstName}</p>
                          )}
                        </div>
                        <div>
                          <label>Last Name</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder="Last Name"
                            type="text"
                            value={user.lastName}
                            onChange={({ target: { value } }) => {
                              const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
                              onValueChange("lastName", filteredValue);
                            }}
                            maxLength={20}
                          />
                          {userValidation.lastName && (
                            <p className="error"> {userValidation.lastName}</p>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <h4 className="mt-0">
                      {userDetail?.firstName} {userDetail?.lastName}{" "}
                    </h4>
                  )}
                </div>

                <p className="text-black-stone d-flex align-items-center">
                  <span>
                    Updated on:{" "}
                    {userDetail?.updatedDate ? Helper.getDatepickerFormatAdminConsole(userDetail?.updatedDate) : ""}{" "}
                  </span>
                  <span className="px-2"> | </span>{" "}
                  <span className="pe-2 d-flex align-items-center">
                    Status:
                    {isEdit ? (
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={user.isActive}
                          onClick={(e) =>
                            onValueChange("isActive", e.target.checked)
                          }
                        />
                        <span className="slider round"></span>
                      </label>
                    ) : (
                      userDetail?.active ? "Active" : "Inactive"
                    )}
                  </span>
                  <span className="px-2"> | </span>{" "}
                  <span>
                    Company Name:{" "}
                    {userDetail?.company ? userDetail?.company : ""}{" "}
                  </span>
                </p>
              </div>
              <div className="user-details-tright">
                {isEdit ? (
                  <>
                    <div className="mb-3">
                      <button
                        className="bs5 btn btn-secondary me-3"
                        onClick={() => setIsEdit(false)}
                      >
                        cancel
                      </button>
                      <button
                        className="bs5 btn btn-primary w200 "
                        onClick={() => {
                          onSubmit();
                        }}
                      >
                        save
                      </button>
                    </div>
                    {/* <div>
                      <button className="bs5 btn btn-secondary w200" disabled>
                        SPONSOR TO AN ACCOUNT
                      </button>
                    </div> */}
                  </>
                ) : (
                  <>
                    {!(userDetail?.source === "SAP") && (
                      <div className="mb-3">
                        <button
                          className="bs5 btn btn-secondary w200"
                          onClick={() => onEditUser()}
                        >
                          Edit
                        </button>
                      </div>
                    )}
                    <div>
                      <button
                        className="bs5 btn btn-secondary w200"
                        onClick={() => openPopup()}
                        disabled={userDetail?.source === "SAP"}
                      >
                        SPONSOR TO AN ACCOUNT
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="user-details-bottom">
            <ul>
              <li>
                <div className="container">
                  <div className="user-details-bottom-left">
                    <i>
                      <img src={userphone} className="me-2" />
                    </i>
                    {isEdit &&
                      !System.validateDomain(userDetail?.emailAddress) ? (
                      <div className="d-flex align-items-center user-contact">
                        <div className="me-3">
                          <label>Mobile</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder="Mobile"
                            type="text"
                            value={user.mobileNumber}
                            onChange={({ target: { value } }) =>
                              onValueChange("mobileNumber", value)
                            }
                          />
                        </div>
                        <div>
                          <label>Telephone</label>
                          <input
                            className="ps-2 form-control form-control-sm w200 mb-0"
                            placeholder="Teletphone"
                            type="text"
                            value={user.telephoneNumber}
                            onChange={({ target: { value } }) =>
                              onValueChange("telephoneNumber", value)
                            }
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <p className="mb-0 text-black-stone">
                          {" "}
                          M: {userDetail?.mobileNumber}
                        </p>{" "}
                        <span className="px-3"> |</span>
                        <p className="mb-0 text-black-stone">
                          {" "}
                          T: {userDetail?.telephoneNumber}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="text-black-stone user-details-bottom-right">
                    <i>
                      <img src={useremail} className="me-2" />
                    </i>{" "}
                    <p className="mb-0 text-black-stone">
                      {" "}
                      {userDetail?.emailAddress}
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="container">
                  <div className="text-black-stone user-details-bottom-left">
                    <i>
                      <img src={usersource} className="me-2" />
                    </i>{" "}
                    <p className="mb-0 text-black-stone">
                      {" "}
                      Source: {userDetail?.source}
                    </p>
                  </div>
                  <div className="text-black-stone user-details-bottom-right">
                    <i>
                      <img src={usercreated} className="me-2" />
                    </i>{" "}
                    <p className="mb-0 text-black-stone">
                      Created on:{" "}
                      {userDetail?.createDate
                        ? Helper.getDatepickerFormatAdminConsole(userDetail?.createDate)
                        : ""}{" "}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default UserDetailHeader;
